/**
 * Shared helpers for the sitemap admin UI and the public /sitemap page.
 *
 * The XML at /sitemap.xml is still the source of truth for *which* URLs exist,
 * but neither surface reads it from the browser any more: at ~29k URLs / 5+ MB
 * the fetch-and-DOM-parse froze the admin tab. The nightly generator mirrors
 * the entry set into public.sitemap_xml_entries instead, and both surfaces
 * query that (see scripts/lib/syncSitemapEntries.ts).
 */

/** Human label for a path when no override is set. */
export function humanisePath(path: string): string {
  if (path === "/" || path === "") return "Home";
  const segs = path.replace(/^\//, "").split("/").filter(Boolean);
  return segs
    .map((s) =>
      s
        .replace(/[-_]+/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase()),
    )
    .join(" › ");
}
